import { render, staticRenderFns } from "./SalesmanTaskSummary.vue?vue&type=template&id=087b601c&"
import script from "./SalesmanTaskSummary.vue?vue&type=script&lang=js&"
export * from "./SalesmanTaskSummary.vue?vue&type=script&lang=js&"
import style0 from "./SalesmanTaskSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports